// noinspection JSUnusedGlobalSymbols
/**
 *
 */
export default class Upsell {
  /**
   *
   * @type {{productList: string}}
   */
  selectors = {
    productList: '.product-list',
  }

  /**
   *
   * @type {{productId: string, productLimit: string, sectionId: string, cartProductIds: string, intent: string}}
   */
  attributes = {
    sectionId: 'data-section-id',
    cartProductIds: 'data-cart-product-ids',
    productId: 'data-product-id',
    productLimit: 'data-product-limit',
    intent: 'data-intent',
  }

  /**
   *
   * @type {Map<String, Element>}
   */
  products = new Map()

  /**
   *
   * @type {HTMLElement|null}
   */
  productList = null

  /**
   *
   * @type {[]}
   */
  cartProductIds = []

  /**
   *
   * @type {number}
   */
  limit

  /**
   *
   * @type {String|null}
   */
  sectionId = null

  /**
   *
   * @param {HTMLElement} container
   */
  constructor (container) {
    this.sectionId = container.getAttribute(this.attributes.sectionId)
    this.intent = container.getAttribute(this.attributes.intent)
    this.productList = container.querySelector(this.selectors.productList)
    this.cartProductIds = container.hasAttribute(this.attributes.cartProductIds)
      ? container.getAttribute(this.attributes.cartProductIds).split(',')
      : []
    this.limit = Number.parseInt(
      container.getAttribute(this.attributes.productLimit))
  }

  /**
   *
   * @return {Promise<void>}
   */
  async init () {
    if (this.cartProductIds && this.cartProductIds.length > 0) {
      await this.fetchAllRecommendations(this.cartProductIds)
    }

    this.fetchDefaultRecommendations()

    this.fillProductList()
  }

  /**
   *
   */
  fetchDefaultRecommendations () {
    Array.from(this.productList.children).
      forEach(element => this.addProductToList(element))
  }

  /**
   *
   * @param {HTMLElement} element
   */
  addProductToList (element) {
    const productId = element.getAttribute(this.attributes.productId)

    if (this.shouldBeAddedToProductList(productId)) {
      this.products.set(productId, element)
    }
  }

  /**
   *
   * @param {String[]} ids
   * @return {Promise<Awaited<unknown>[] | void>}
   */
  fetchAllRecommendations (ids) {
    return Promise.all(ids.map(id => this.fetchProductRecommendations(id))).
      catch(console.error)
  }

  /**
   *
   * @param id
   * @return {Promise<string>}
   */
  fetchProductRecommendations (id) {
    return fetch(
      `/recommendations/products?product_id=${id}&section_id=${this.sectionId}&intent=${this.intent}`).
      then(response => response.text()).
      then((text) => {
        this.getProductElements(text).
          forEach(element => this.addProductToList(element))
      })
  }

  /**
   *
   */
  fillProductList () {
    this.productList.innerHTML = ''

    this.productList.append(
      ...Array.from(this.products.values()).slice(0, this.limit))
  }

  /**
   *
   * @param text
   * @return {Element[]}
   */
  getProductElements (text) {
    const parser = new DOMParser()
    const parsedDocument = parser.parseFromString(text, 'text/html')
    const section = parsedDocument.getElementById(
      `shopify-section-${this.sectionId}`)

    return section ? Array.from(section.children) : []
  }

  /**
   *
   * @param {String} productId
   * @return {*|boolean}
   */
  shouldBeAddedToProductList (productId) {
    return productId
      && !this.cartProductIds.includes(productId)
      && !this.products.has(productId)
  }
}
